import { useTranslation } from 'react-i18next';
import { api } from '../../services/api';
import { useAsync } from '../../hooks/useAsync';
import { int, useQueryParams } from '../../hooks/useQueryParams';
import { dateTime } from '../../services/format';
import { Alert, Cell, Field, Filters, Input, PageTitle, Pager, Row, Select, Table } from '../../components/ui';

const PAGE_SIZE = 50;

export function AuditList() {
  const { t, i18n } = useTranslation();
  const { get, page, set, reset, setPage } = useQueryParams();
  const action = get('action');
  const targetKind = get('target_kind');
  const targetId = get('target_id');
  const actorId = get('actor_id');
  const { data, error, loading } = useAsync(() => api.audit({ action: action || undefined, target_kind: targetKind || undefined, target_id: targetId || undefined, actor_id: int(actorId), page, page_size: PAGE_SIZE }), [action, targetKind, targetId, actorId, page]);

  return (
    <div>
      <PageTitle title={t('audit.title')} subtitle={data ? t('common.count', { count: data.total }) : undefined} />
      <Filters onReset={reset}>
        <Field label={t('audit.action')} hint={t('audit.actionHint')} className="w-56">
          <Input value={action} onChange={(e) => set({ action: e.target.value })} placeholder="admin." />
        </Field>
        <Field label={t('audit.targetKind')}>
          <Select value={targetKind} onChange={(e) => set({ target_kind: e.target.value })}>
            <option value="">{t('common.any')}</option>
            {['user', 'organization', 'invoice', 'mail'].map((k) => (
              <option key={k} value={k}>
                {k}
              </option>
            ))}
          </Select>
        </Field>
        <Field label={t('audit.targetId')} className="w-32">
          <Input value={targetId} onChange={(e) => set({ target_id: e.target.value })} />
        </Field>
        <Field label={t('audit.actor')} className="w-32">
          <Input type="number" value={actorId} onChange={(e) => set({ actor_id: e.target.value })} />
        </Field>
      </Filters>
      {error && <Alert>{error}</Alert>}
      <Table head={[t('audit.when'), t('audit.action'), t('audit.target'), t('audit.actor'), t('audit.data')]} empty={loading ? t('common.loading') : t('common.empty')}>
        {(data?.items ?? []).map((e) => (
          <Row key={e.id}>
            <Cell mono>{dateTime(e.created_at, i18n.language)}</Cell>
            <Cell mono>{e.action}</Cell>
            <Cell mono>
              {e.target_kind} #{e.target_id}
            </Cell>
            <Cell mono>{e.actor_id ?? '—'}</Cell>
            <Cell mono className="max-w-lg">
              <code className="block truncate" title={JSON.stringify(e.data)}>
                {JSON.stringify(e.data)}
              </code>
            </Cell>
          </Row>
        ))}
      </Table>
      {data && <Pager page={data.page} pageSize={data.page_size} total={data.total} onPage={setPage} />}
    </div>
  );
}
